"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _propTypes = require("prop-types");

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _useClickOutside = _interopRequireDefault(require("../../hooks/useClickOutside"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\twidth: max-content;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n\ttop: 8px;\n\twidth: max-content;\n\tpadding: ", ";\n\tcolor: white;\n\tbackground: ", ";\n\tfont-size: 1rem;\n\tborder-radius: ", ";\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tleft: 8px;\n\t\ttop: -8px;\n\t\tborder-left: 8px solid transparent;\n\t\tborder-right: 8px solid transparent;\n\t\tborder-bottom: 8px solid ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var CopiedToClipboard = _styledComponents.default.div(_templateObject(), _spacing.default.s1, _colors.default.primary, _vars.default.borderRadius, _colors.default.primary);

CopiedToClipboard.displayName = 'CopiedToClipboard';

var Container = _styledComponents.default.div(_templateObject2());

Container.displayName = 'Container';

var LinkTo = _styledComponents.default.span(_templateObject3(), _colors.default.primary);

LinkTo.displayName = 'LinkTo';

var CopyToClipboard = function CopyToClipboard(_ref) {
  var textToCopy = _ref.textToCopy,
      children = _ref.children,
      successfullyCopied = _ref.successfullyCopied,
      onCopy = _ref.onCopy;
  var successMessageTimer;

  var _useState = (0, _react.useState)(false),
      urlCopied = _useState[0],
      setConfirmation = _useState[1];

  var handleCopy = function handleCopy() {
    (0, _copyToClipboard.default)(textToCopy);
    clearTimeout(successMessageTimer);
    setConfirmation(true);
    successMessageTimer = setTimeout(function () {
      return setConfirmation(false);
    }, 2000);

    if (onCopy) {
      onCopy(textToCopy);
    }
  };

  var nodeRef = (0, _useClickOutside.default)(function () {
    clearTimeout(successMessageTimer);
    setConfirmation(false);
  });
  return _react.default.createElement(Container, null, _react.default.createElement(LinkTo, {
    onClick: handleCopy
  }, children), urlCopied && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(CopiedToClipboard, {
    ref: nodeRef
  }, successfullyCopied)));
};

CopyToClipboard.propTypes = {
  textToCopy: _propTypes.string.isRequired,
  children: _propTypes.node.isRequired,
  successfullyCopied: _propTypes.string,
  onCopy: _propTypes.func
};
CopyToClipboard.defaultProps = {
  successfullyCopied: 'Copied to clipboard',
  onCopy: undefined
};
var _default = CopyToClipboard;
exports.default = _default;